import { render, staticRenderFns } from "./TicketManager.vue?vue&type=template&id=f127c280"
import script from "./TicketManager.vue?vue&type=script&lang=js"
export * from "./TicketManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports